module.exports = __webpack_public_path__ + "static/media/allow-calculator.52fa8625.svg";